module.exports = __webpack_public_path__ + "static/media/socmed.1ca798b2.svg";